import Preloader from '@/components/preloaders/Preloader';

const FullHeightPreloader = () => <Preloader class="h-full" />
const Error = () => (
  <p
    class="flex items-center justify-center h-full"
  >Не удалось загрузить компонент. Попробуйте перезагрузить страницу.</p>
);

/**
 * @param {() => Promise<Vue.Component>} importFunc
 */
export default function asyncComponentWithLoading(importFunc) {
  return () => ({
    component: importFunc(),
    loading: FullHeightPreloader,
    error: Error,
  });
}
